import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ActivityFeed } from "@/features/activity/components/activity-feed";

// F4-A: activity feed (SINGLE path: GET /api/activity over the master log).
export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: ActivityFeed,
});
